import React, { useEffect, useRef } from "react";
import SizeFinder from "../components/SizeFinder";

export default function WidgetPage() {
  const ref = useRef(null);

  useEffect(() => {
    const postHeight = () => {
      const h = Math.ceil(
        (ref.current ? ref.current.offsetHeight : document.body.scrollHeight) + 2
      );
      if (window.parent) {
        window.parent.postMessage({ type: "sf-height", height: h }, "*");
      }
    };
    postHeight();
    const ro = new ResizeObserver(postHeight);
    if (ref.current) ro.observe(ref.current);
    window.addEventListener("load", postHeight);
    const t = setInterval(postHeight, 600);
    setTimeout(() => clearInterval(t), 4000);
    return () => {
      ro.disconnect();
      window.removeEventListener("load", postHeight);
      clearInterval(t);
    };
  }, []);

  return (
    <div ref={ref} className="w-full max-w-[440px] mx-auto bg-[#0A0A0A]">
      <SizeFinder compact />
    </div>
  );
}
